import { VehicleService } from "services/vehicle/vehicle";
import slugify from "slugify";

const enquiryLinkResolver = (vehicle: VehicleService.Vehicle, isTestDrive = false): string => {
    const { Manufacturer: make, Model: model, Variant: variant } = vehicle.Taxonomy;
    const lowerMake = slugify(make, { lower: true });
    const lowerModel = slugify(model, { lower: true });
    const lowerVariant = slugify(variant, { lower: true });

    const id = vehicle?.LegacyVehicleId ?? vehicle?.StockBookNumber;
    return `/used-cars/${lowerMake}/${lowerModel}/${lowerVariant}/${id}/${
        !!isTestDrive ? "test-drive" : "enquire"
    }`;
};

export default enquiryLinkResolver;
